/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ portal: NonNullable<unknown>, level: NonNullable<unknown> }} Portals_Matrix_OkInputs */

const cs_portals_matrix_ok = /** @type {(inputs: Portals_Matrix_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.portal}: OK (${i?.level})`)
};

const en_portals_matrix_ok = /** @type {(inputs: Portals_Matrix_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.portal}: OK (${i?.level})`)
};

/**
* | output |
* | --- |
* | "{portal}: OK ({level})" |
*
* @param {Portals_Matrix_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_ok = /** @type {((inputs: Portals_Matrix_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_ok(inputs)
	return cs_portals_matrix_ok(inputs)
});